var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTotalShifts(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50.1953,
    height: 50.1953,
    rx: 6,
    fill: "#E1EBE3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.6667 27.4V30.04L30.6222 31.24M28.6667 15.4H31.1111C31.7594 15.4 32.3812 15.6529 32.8396 16.1029C33.298 16.553 33.5556 17.1635 33.5556 17.8V18.7984M18.8889 15.4H16.4444C15.7961 15.4 15.1744 15.6529 14.716 16.1029C14.2575 16.553 14 17.1635 14 17.8V34.6C14 35.2365 14.2575 35.847 14.716 36.2971C15.1744 36.7471 15.7961 37 16.4444 37H18.8889M36 29.8C36 33.7765 32.7168 37 28.6667 37C24.6166 37 21.3333 33.7765 21.3333 29.8C21.3333 25.8236 24.6166 22.6 28.6667 22.6C32.7168 22.6 36 25.8236 36 29.8ZM20.1111 13H27.4444C28.1195 13 28.6667 13.5373 28.6667 14.2V16.6C28.6667 17.2627 28.1195 17.8 27.4444 17.8H20.1111C19.4361 17.8 18.8889 17.2627 18.8889 16.6V14.2C18.8889 13.5373 19.4361 13 20.1111 13Z",
    stroke: "#448E7B",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalShifts);
export default __webpack_public_path__ + "static/media/total-shifts.bfcdfe9326f4776dd20a587af06b369b.svg";
export { ForwardRef as ReactComponent };